import { useState } from "react";
import { Icon } from "@iconify/react";
import { submitForm } from "./utils/api";
import { isValidEmail, isValidUKPhone } from "./utils/validation";

const AssessmentForm = ({ clientKey, formId }) => {
     const [fieldErrors, setFieldErrors] = useState({});

     const [parentName, setParentName] = useState("");
     const [studentName, setStudentName] = useState("");
     const [email, setEmail] = useState("");
     const [phone, setPhone] = useState("");
     const [assessmentDate, setAssessmentDate] = useState("");

     const [loading, setLoading] = useState(false);
     const [success, setSuccess] = useState(null);
     const [error, setError] = useState(null);

     const validate = () => {
          const errors = {};
          const cleanEmail = email?.trim();

          if (cleanEmail && !isValidEmail(cleanEmail)) {
               errors.email = "Please enter a valid email address.";
          }

          if (phone && !isValidUKPhone(phone)) {
               errors.phone = "Please enter a valid UK phone number.";
          }

          if (!assessmentDate) {
               errors.assessmentDate = "Please select a date.";
          }

          setFieldErrors(errors);
          return Object.keys(errors).length === 0;
     };

     const handleSubmit = async (e) => {
          e.preventDefault();

          setLoading(true);
          setSuccess(null);
          setError(null);

          if (!validate()) {
               setError("Please fix the errors above");
               setLoading(false);
               return;
          }

          try {
               const response = await submitForm({
                    client: clientKey,
                    formid: formId,

                    parentName,
                    studentName,
                    email,
                    phone,
                    assessmentDate,
               });

               if (response.status === 200) {
                    setSuccess("Your details have been submitted successfully!");
               } else {
                    setError("Something went wrong, please try again.");
               }
          } catch (err) {
               setError("Error occurred. Please try again.");
          } finally {
               setLoading(false);
          }
     };

     const nextSaturdays = (() => {
          const dates = [];
          const today = new Date();

          let nextSaturday = new Date(today);

          while (nextSaturday.getDay() !== 6) {
               nextSaturday.setDate(nextSaturday.getDate() + 1);
          }

          for (let i = 0; i < 3; i++) {
               const date = new Date(nextSaturday);

               dates.push({
                    label:
                         "10:00 AM, " +
                         date.toLocaleDateString("en-GB", {
                              weekday: "long",
                              day: "numeric",
                              month: "long",
                         }),
                    value: date.toISOString().split("T")[0] + " 10:00",
               });

               nextSaturday.setDate(nextSaturday.getDate() + 7);
          }

          return dates;
     })();

     return (
          <div className="form-container">
               <form onSubmit={handleSubmit} className="form-inner" noValidate>

                    <section className="sect1">
                         <h3>Assessment Form</h3>
                         <div className="sect">
                              <label>Parent's Name</label>
                              <div className="padder">
                                   <input
                                        type="text"
                                        placeholder="enter parent's name..."
                                        value={parentName}
                                        onChange={(e) => setParentName(e.target.value)}
                                        required
                                   />
                              </div>
                         </div>

                         <div className="sect">
                              <label>Student's Name</label>
                              <div className="padder">
                                   <input
                                        type="text"
                                        placeholder="enter student's name..."
                                        value={studentName}
                                        onChange={(e) => setStudentName(e.target.value)}
                                        required
                                   />
                              </div>
                         </div>

                         <div className="sect">
                              <label>Email Address</label>
                              <div className="padder">
                                   <input
                                        type="email"
                                        placeholder="enter your email..."
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                   />
                              </div>
                              {fieldErrors.email && (
                                   <span className="error-text">{fieldErrors.email}</span>
                              )}
                         </div>

                         <div className="sect">
                              <label>Phone Number</label>
                              <div className="padder">
                                   <input
                                        type="tel"
                                        placeholder="enter phone number..."
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                        required
                                   />
                              </div>
                              {fieldErrors.phone && (
                                   <span className="error-text">{fieldErrors.phone}</span>
                              )}
                         </div>

                         <div className="sect">
                              <label>Choose assessment date</label>
                              <div className="padder">
                                   <select
                                        value={assessmentDate}
                                        onChange={(e) => setAssessmentDate(e.target.value)}
                                        required
                                   >
                                        <option value="">Select a date</option>

                                        {nextSaturdays.map((date) => (
                                             <option key={date.value} value={date.value}>
                                                  {date.label}
                                             </option>
                                        ))}
                                   </select>
                                   <span className="select-icon">
                                        <Icon icon="gridicons:dropdown" />
                                   </span>
                              </div>
                              {fieldErrors.assessmentDate && (
                                   <span className="error-text">{fieldErrors.assessmentDate}</span>
                              )}
                         </div>

                    </section>
                    <section className="sect2">
                         <h3>Assessment requirements</h3>
                         <p>Students will be required to turn on their webcams and microphones for cheating mitigation. By clicking submit you are confirming that they will do that.</p>
                         <button disabled={loading}>
                              {loading ? "Sending..." : "Submit"}
                         </button>
                    </section>

                    {success && <div className="success-message">{success}</div>}
                    {error && <div className="error-message">{error}</div>}
               </form >
          </div >
     );
};

export default AssessmentForm;